module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_19_C_2.3509aa9a.mp3";